import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  Form,
  reduxForm,
} from 'redux-form';

import Button from '@material-ui/core/Button';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import Typography from '@material-ui/core/Typography';

import FormInput from '@components/FormInput/FormInput';
import Icon from '@components/Icon/Icon';

import {
  required,
  email,
} from '@utils/validators';

import './LoginForm.scss';

const LoginForm = ({
  error,
  handleSubmit,
  submitting,
}) => (
  <div className="login-form">
    <Form
      onSubmit={handleSubmit}
    >
      <div className="login-form__form-control">
        <Icon className="login-form__icon-container">
          <EmailIcon />
        </Icon>
        <Field
          name="username"
          label="Email:"
          type="email"
          placeholder="Type your email..."
          validate={[required, email]}
          component={FormInput}
        />
      </div>
      <div className="login-form__form-control">
        <Icon className="login-form__icon-container">
          <LockIcon />
        </Icon>
        <Field
          name="password"
          label="Password:"
          type="password"
          placeholder="Type your password..."
          validate={required}
          component={FormInput}
        />
      </div>
      <div className="login-form__button-container">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={submitting}
        >
          Log In
        </Button>
      </div>
      {error && error.map((singleError, index) => (
        <div
          className="login-form__error"
          key={index}
        >
          <Typography color="error">
            {singleError}
          </Typography>
        </div>
      ))}
    </Form>
  </div>
);

LoginForm.propTypes = {
  error: PropTypes.arrayOf(PropTypes.string),
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

LoginForm.defaultProps = {
  error: [],
};

export default reduxForm({
  form: 'login-form',
  destroyOnUnmount: false,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/routes/forms/LoginForm/LoginForm.js